import { render, staticRenderFns } from "./PickerIndex.vue?vue&type=template&id=fa613b9a&"
import script from "./PickerIndex.vue?vue&type=script&lang=ts&"
export * from "./PickerIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PickerIndex.vue?vue&type=style&index=0&id=fa613b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports